import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "uk-container" }
const _hoisted_2 = { class: "uk-text-small uk-text-small uk-table-middle uk-table uk-table-condensed uk-table-small uk-table-divide uk-table-small uk-table-striped uk-table-justify uk-table-middle uk-table-hover" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "uk-text-center" }
const _hoisted_5 = { class: "uk-text-center" }
const _hoisted_6 = {
  key: 0,
  class: "uk-text-center"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "uk-text-center"
}
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CarrierDetailModal = _resolveComponent("CarrierDetailModal")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Modal, {
      isOpen: _ctx.isCarrierDetailsOpen,
      "onUpdate:isOpen": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCarrierDetailsOpen) = $event)),
      modalId: "carrier-details-modal",
      maxWidth: "5xl",
      onClose: _ctx.closeCarrierDetails
    }, {
      title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode("Carrier Details", -1)
      ]))]),
      content: _withCtx(() => [
        (_ctx.selectedBrokerCarrierAssociation)
          ? (_openBlock(), _createBlock(_component_CarrierDetailModal, {
              key: 0,
              brokerCarrierAssociation: _ctx.selectedBrokerCarrierAssociation
            }, null, 8, ["brokerCarrierAssociation"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isOpen", "onClose"]),
    _createElementVNode("table", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", { class: "uk-text-center uk-text-normal" }, "Name"),
          _createElementVNode("th", { class: "uk-text-bold uk-text-center" }, "Number of Loads Carried"),
          _createElementVNode("th", { class: "uk-text-center uk-text-bolder" }, "Onboarding Status"),
          _createElementVNode("th")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brokerCarrierAssociations, (brokerCarrierAssociation) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: brokerCarrierAssociation.company2.id,
            onClick: ($event: any) => (_ctx.selectCarrier(brokerCarrierAssociation.company2.id, $event))
          }, [
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("b", null, _toDisplayString(brokerCarrierAssociation.customCarrierName), 1)
              ])
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("td", { class: "uk-text-center" }, _toDisplayString(0), -1)),
            _createElementVNode("td", _hoisted_5, _toDisplayString(brokerCarrierAssociation.onboardingStatus), 1),
            (brokerCarrierAssociation.onboardingStatus === 'NA')
              ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "uk-button uk-button-large uk-button-primary uk-form-controls",
                    onClick: ($event: any) => (_ctx.startCarrierOnboarding(brokerCarrierAssociation.company2.id, $event))
                  }, " Start Onboarding ", 8, _hoisted_7)
                ]))
              : (_openBlock(), _createElementBlock("td", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "uk-button uk-button-large uk-button-primary uk-form-controls uk-button-disabled",
                    onClick: ($event: any) => (_ctx.startCarrierOnboarding(brokerCarrierAssociation.company2.id)),
                    disabled: ""
                  }, " Start Onboarding ", 8, _hoisted_9)
                ]))
          ], 8, _hoisted_3))
        }), 128))
      ])
    ])
  ]))
}